module.exports = __webpack_public_path__ + "static/media/pizzaPolloChampinones.9717c4a1.jpg";